<template>
  <div class="container-fluid mt-7">
    <div class="card border-0 shadow-lg rounded-lg">
      <div class="card-header bg-primary text-white py-3">
        <h4 class="mb-0 text-white">
          <i :class="isEditMode ? 'fa fa-edit mr-2' : 'fa fa-user-plus mr-2'"></i>
          {{ isEditMode ? 'Edit User' : 'Add New User' }}
        </h4>
      </div>
      <div class="card-body">
        <Form @submit="handleOnboard">
          <div class="border-bottom pb-3 mb-4">
            <h4 class="text-dark mb-3">Basic Information</h4>
            <div class="form-row">
              <div class="form-group col-md-4">
                <label>User ID</label>
                <Field name="userId" v-model="user.userId" type="text" class="form-control" placeholder="Enter User ID"
                  rules="required" :disabled="isEditMode" :class="{ 'bg-table': isEditMode }" />
                <ErrorMessage name="userId" class="text-danger small" />
              </div>
              <div class="form-group col-md-4">
                <label>First Name</label>
                <Field name="first Name" v-model="user.firstName" type="text" class="form-control"
                  placeholder="Enter First Name" rules="required" />
                <ErrorMessage name="first Name" class="text-danger small" />
              </div>
              <div class="form-group col-md-4">
                <label>Last Name</label>
                <Field name="Last Name" v-model="user.lastName" type="text" class="form-control"
                  placeholder="Enter Last Name" rules="required" />
                <ErrorMessage name="Last Name" class="text-danger small" />
              </div>
              <div class="form-group col-md-4">
                <label>Nickname</label>
                <Field name="Nickname" v-model="user.nickName" type="text" class="form-control"
                  placeholder="Enter Nickname" rules="required" />
                <ErrorMessage name="Nickname" class="text-danger small" />
              </div>
              <div class="form-group col-md-4">
                <label>Broker</label>
                <Field name="Broker" rules="required" v-model="user.broker">
                  <template #default="{ value, handleChange }">
                    <el-select :model-value="value" @change="handleChange" filterable placeholder="Select Broker"
                      class="w-100">
                      <el-option v-for="(broker, index) in brokerOptions" :key="broker.id" :label="broker.name"
                        :value="broker.id" />
                    </el-select>
                  </template>
                </Field>
                <ErrorMessage name="Broker" class="text-danger small" />
              </div>
              <div class="form-group col-md-4">
                <label>Status</label>
                <Field name="Status" rules="required" v-model="user.status">
                  <template #default="{ value, handleChange }">
                    <el-select :model-value="value" @change="handleChange" filterable clearable
                      placeholder="Select Status" class="w-100">
                      <el-option label="Active" value="ACTIVE" />
                      <el-option label="Disabled" value="DISABLED" />
                    </el-select>
                  </template>
                </Field>
                <ErrorMessage name="Status" class="text-danger small" />
              </div>
            </div>
          </div>
          <div class="border-bottom pb-3 mb-4">
            <h4 class="text-dark mb-3">Security & Access</h4>
            <div class="form-row">
              <div class="form-group col-md-4 position-relative">
                <label>PIN</label>
                <div class="input-group">
                  <input name="PIN" :type="show.pin ? 'text' : 'password'" v-model="user.pin" class="form-control"
                    rules="required" placeholder="Enter PIN" autocomplete="new-password" />
                  <div class="input-group-append">
                    <button class="btn border bg-white" type="button" @click="toggleShow('pin')">
                      <i :class="show.pin ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="form-group col-md-4 position-relative">
                <label>API Key</label>
                <div class="input-group">
                  <Field name="API Key" :type="show.apiKey ? 'text' : 'password'" v-model="user.apiKey"
                    class="form-control" rules="required" placeholder="Enter API Key" />
                  <div class="input-group-append">
                    <button class="btn border bg-white" type="button" @click="toggleShow('apiKey')">
                      <i :class="show.apiKey ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                    </button>
                  </div>
                </div>
                <ErrorMessage name="API Key" class="text-danger small" />
              </div>
              <div class="form-group col-md-4 position-relative">
                <label>API Secret</label>
                <div class="input-group">
                  <Field name="API Secret" :type="show.apiSecret ? 'text' : 'password'" v-model="user.apiSecret"
                    class="form-control" rules="required" placeholder="Enter API Secret" />
                  <div class="input-group-append">
                    <button class="btn border bg-white" type="button" @click="toggleShow('apiSecret')">
                      <i :class="show.apiSecret ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                    </button>
                  </div>
                </div>
                <ErrorMessage name="API Secret" class="text-danger small" />
              </div>
              <div class="form-group col-md-4 position-relative">
                <label>TOTP Secret</label>
                <div class="input-group">
                  <input :type="show.totpSecret ? 'text' : 'password'" v-model="user.totpSecret" class="form-control"
                    placeholder="Enter TOTP Secret" />
                  <div class="input-group-append">
                    <button class="btn border bg-white" type="button" @click="toggleShow('totpSecret')">
                      <i :class="show.totpSecret ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="form-group col-md-4 position-relative">
                <label>Secret</label>
                <div class="input-group">
                  <input name="Secret" :type="show.secret ? 'text' : 'password'" v-model="user.secret"
                    class="form-control" rules="required" placeholder="Enter Secret" />
                  <div class="input-group-append">
                    <button class="btn border bg-white" type="button" @click="toggleShow('secret')">
                      <i :class="show.secret ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="border-bottom pb-3 mb-4">
            <h4 class="text-dark mb-3">Portfolio Settings</h4>
            <div class="form-row">
              <div class="form-group col-md-4">
                <label>Loss Percentage</label>
                <Field name="Loss Percentage" v-model="user.lossPercentage" type="text" class="form-control"
                  placeholder="e.g. 10,20" rules="required" />
                <ErrorMessage name="Loss Percentage" class="text-danger small" />
              </div>
              <div class="form-group col-md-4">
                <label>Profit Percentage</label>
                <Field name="Profit Percentage" v-model="user.profitPercentage" type="text" class="form-control"
                  placeholder="e.g. 5,15" rules="required" />
                <ErrorMessage name="Profit Percentage" class="text-danger small" />
              </div>
              <div class="form-group col-md-4">
                <label>Portfolio Size</label>
                <Field name="Portfolio Size" v-model="user.portfolioSize" rules="required" v-slot="{ field }">
                  <input type="text" class="form-control" :value="formattedPortfolioDisplay"
                    @input="handlePortfolioSizeInput($event, field)" placeholder="Enter Portfolio Size" />
                </Field>
                <ErrorMessage name="Portfolio Size" class="text-danger small" />
              </div>
              <div class="form-group col-md-4">
                <label>Portfolio Profit Enabled</label>
                <el-select v-model="user.portfolioProfitEnabled" filterable clearable
                  placeholder="Select Portfolio Profit Status" class="w-100">
                  <el-option label="Active" value="ACTIVE" />
                  <el-option label="Disabled" value="DISABLED" />
                </el-select>
              </div>
              <div class="form-group col-md-4">
                <label>Square Off Enabled</label>
                <el-select v-model="user.squareoffEnabled" filterable clearable placeholder="Select Square Off Status"
                  class="w-100">
                  <el-option label="Active" value="ACTIVE" />
                  <el-option label="Disabled" value="DISABLED" />
                </el-select>
              </div>
            </div>
          </div>
          <div v-if="!isBucketEmpty" class="border-bottom pb-3 mb-4">
            <h4 class="text-dark mb-3">Bucket Percentage Settings</h4>
            <div class="form-row align-items-start mb-2" v-for="(entry, index) in user.bucketPercentages"
              :key="'bucket-' + index">
              <div class="form-group col-md-5 mb-0">
                <el-select v-model="entry.variable" filterable clearable placeholder="Select Variable" class="w-100">
                  <el-option v-for="(option, i) in bucketVariableOptions" :key="i" :label="option.replace(/_/g, ' ')"
                    :value="option" />
                </el-select>
              </div>
              <div class="form-group col-md-5 mb-0">
                <input type="text" v-model="entry.value" class="form-control" placeholder="e.g. 5,10,15" />
              </div>
              <div class="form-group col-md-2 mb-0 d-flex align-items-end">
                <button class="btn btn-danger" type="button" @click="removeBucket(index)">
                  <i class="fa fa-trash"></i>
                </button>
              </div>
            </div>
            <button class="btn btn-outline-primary" type="button" @click="addBucket">
              <i class="fa fa-plus"></i> Add Bucket
            </button>
          </div>
          <div v-else class="border-bottom pb-3 mb-4">
            <h4 class="text-dark mb-3">Bucket Percentage Settings</h4>
            <button class="btn btn-outline-primary" type="button" @click="initializeBucket">
              <i class="fa fa-plus"></i> Add Bucket
            </button>
          </div>
          <div class="border-bottom pb-3 mb-4">
            <h4 class="text-dark mb-3">Proxy Settings</h4>
            <div class="form-row">
              <div class="form-group col-md-4">
                <label>Host</label>
                <input type="text" v-model="user.host" class="form-control"
                  placeholder="Proxy host (e.g., 159.43.50.40)" />
              </div>
              <div class="form-group col-md-4">
                <label>Port</label>
                <input type="text" v-model="user.port" class="form-control" placeholder="Proxy port (e.g., 3128)" />
              </div>
              <div class="form-group col-md-4">
                <label>Type</label>
                <input type="text" v-model.trim="user.type" class="form-control"
                  placeholder="Proxy type (e.g., http, https)" @input="user.type = (user.type || '').toLowerCase()" />
              </div>
              <div class="form-group col-md-4">
                <label>Username</label>
                <input type="text" v-model="user.username" class="form-control" placeholder="Proxy username" />
              </div>
              <div class="form-group col-md-4">
                <label>Password</label>
                <div class="input-group">
                  <input :type="show.proxyPassword ? 'text' : 'password'" v-model="user.password" class="form-control"
                    placeholder="Proxy password" />
                  <div class="input-group-append">
                    <button class="btn border bg-white" type="button" @click="show.proxyPassword = !show.proxyPassword">
                      <i :class="show.proxyPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="border-bottom pb-3 mb-4">
            <h4 class="text-dark mb-3">XTS Settings</h4>
            <div class="form-row">
              <div class="form-group col-md-4">
                <label>Port</label>
                <Field name="XTS Port" v-model="user.xtsPort" type="text" class="form-control"
                  placeholder="e.g., 3100" />
              </div>
              <div class="form-group col-md-4">
                <label>Limit Percentage</label>
                <Field name="XTS Limit %" v-model="user.xtsLimitPercentage" type="text" class="form-control"
                  placeholder="e.g., 50" />
              </div>
              <div class="form-group col-md-4">
                <label>Common URL</label>
                <Field name="XTS Common URL" v-model="user.xtsCommonUrl" type="text" class="form-control"
                  placeholder="https://api.example.com" />
              </div>
              <div class="form-group col-md-4">
                <label>Version</label>
                <Field name="XTS Version" v-model="user.xtsVersion" type="text" class="form-control"
                  placeholder="e.g., v1 or 1.0.0" />
              </div>
              <div class="form-group col-md-4 d-flex align-items-center mt-4 mx-2">
                <el-checkbox v-model="user.xtsIsLimitOrder"><span class="font-weight-bold">Is Limit
                    Order</span></el-checkbox>
              </div>
            </div>
          </div>
          <div v-if="!isPortfolioEmpty" class="pb-3 mb-4">
            <h4 class="text-dark mb-3">Types & Multipliers</h4>
            <div class="form-row align-items-start mb-2" v-for="(entry, index) in user.types" :key="index">
              <div class="form-group col-md-5 mb-0">
                <Field :name="`type-${index}`" rules="required" v-model="entry.type">
                  <template #default="{ value, handleChange }">
                    <el-select :model-value="value" @change="handleChange" filterable clearable
                      placeholder="Select Type" class="w-100">
                      <el-option v-for="(option, i) in typeOptions" :key="i" :label="option.replace(/_/g, ' ')"
                        :value="option" />
                    </el-select>
                  </template>
                </Field>
                <ErrorMessage :name="`type-${index}`" class="text-danger small d-block" />
              </div>
              <div class="form-group col-md-5 mb-0">
                <Field :name="`multiplier-${index}`" v-model="entry.multiplier" type="number" class="form-control"
                  placeholder="Enter Multiplier" :rules="'required'" @input="validateMultiplier(entry)" />
                <ErrorMessage :name="`multiplier-${index}`" class="text-danger small d-block" />
              </div>
              <div class="form-group col-md-2 mb-0 d-flex align-items-end">
                <button class="btn btn-danger" type="button" @click="removeType(index)" v-if="user.types.length > 1">
                  <i class="fa fa-trash"></i>
                </button>
              </div>
            </div>
            <button class="btn btn-outline-primary" type="button" @click="addType">
              <i class="fa fa-plus"></i> Add Type
            </button>
          </div>
          <div v-else class="pb-3 mb-4">
            <button class="btn btn-outline-primary" type="button" @click="isPortfolioEmpty = false">
              <i class="fa fa-plus"></i> Add Portfolio
            </button>
          </div>
          <hr />
          <div class="d-flex justify-content-between">
            <button type="button" class="btn btn-secondary" @click="cancel">Cancel</button>
            <button type="submit" class="btn btn-primary">
              {{ isEditMode ? 'Update' : 'Onboard' }}
            </button>
          </div>
        </Form>
      </div>
    </div>
  </div>
</template>
<script>
import {
  ElSelect,
  ElOption,
  ElCheckbox
} from "element-plus";
import Swal from 'sweetalert2';
import { Field, Form, ErrorMessage } from 'vee-validate';
export default {
  components: {
    Field,
    Form,
    ErrorMessage,
    [ElSelect.name]: ElSelect,
    [ElOption.name]: ElOption,
    [ElCheckbox.name]: ElCheckbox,
  },
  data() {
    const today = new Date();
    const startOfYear = new Date(today.getFullYear(), 0, 1);
    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = (`0${date.getMonth() + 1}`).slice(-2);
      const day = (`0${date.getDate()}`).slice(-2);
      return `${year}-${month}-${day}`;
    };
    return {
      user: {
        userId: '',
        firstName: '',
        lastName: '',
        nickName: '',
        pin: '',
        apiKey: '',
        apiSecret: '',
        totpSecret: '',
        secret: '',
        broker: '',
        status: '',
        portfolioProfitEnabled: '',
        squareoffEnabled: '',
        lossPercentage: '',
        profitPercentage: '',
        portfolioSize: '',
        feeder: false,
        types: [{ type: '', multiplier: '' }],
        host: '',
        port: '',
        type: '',
        username: '',
        password: '',
        xtsPort: '',
        xtsLimitPercentage: '',
        xtsCommonUrl: '',
        xtsIsLimitOrder: false,
        xtsVersion: '',
        bucketPercentages: [],
      },
      show: {
        pin: false,
        apiKey: false,
        apiSecret: false,
        totpSecret: false,
        secret: false,
        proxyPassword: false,
      },
      isEditMode: false,
      brokerOptions: [],
      typeOptions: [],
      fromDate: formatDate(startOfYear),
      toDate: formatDate(today),
      isPortfolioEmpty: false,
      bucketVariableOptions: [
        'IDX_OPT_PROFIT_PERCENTAGE',
        'IDX_OPT_LOSS_PERCENTAGE',
        'COM_OPT_PROFIT_PERCENTAGE',
        'COM_OPT_LOSS_PERCENTAGE',
        'COM_FUT_PROFIT_PERCENTAGE',
        'COM_FUT_LOSS_PERCENTAGE',
      ],
      isBucketEmpty: true,
    };
  },
  mounted() {
    const id = sessionStorage.getItem('onboarding-id');
    this.getPortfolioNames();
    this.getActiveBrokers();
    if (id) {
      this.isEditMode = true;
      this.fetchUserDetails(id);
    }
    window.scrollTo(0, 0);
  },
  computed: {
    formattedPortfolioDisplay() {
      if (!this.user.portfolioSize) return '';
      const amount = this.user.portfolioSize.toString().replace(/\D/g, '');
      const lastThree = amount.slice(-3);
      const otherNumbers = amount.slice(0, -3);
      return otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + (otherNumbers ? ',' : '') + lastThree;
    }
  },
  methods: {
    toBool(val) {
      if (typeof val === 'boolean') return val;
      if (typeof val === 'number') return val !== 0;
      if (typeof val === 'string') return ['true', '1', 'yes', 'y'].includes(val.trim().toLowerCase());
      return false;
    },
    fetchUserDetails(id) {
      this.$store.dispatch("userStore/getUserById", id, { root: true })
        .then(response => {
          const userData = response.server.data;
          if (userData && userData.userId) {
            const portfolioList = userData.referenceDataBeans || {};
            this.isPortfolioEmpty = Object.keys(portfolioList).length === 0;
            const types = portfolioList.map(item => ({
              type: item.key,
              multiplier: item.value
            }));
            const variables = userData.userVariables || [];
            const portfolioSizeVar = variables.find(v => v.name === "PORTFOLIO_SIZE");
            const commonUrlVar = variables.find(v => v.name === "COMMON_URL");
            const xtsPortVar = variables.find(v => v.name === "PORT");
            const xtsLimitPercentageVar = variables.find(v => v.name === "LIMIT_PERCENTAGE");
            const xtsIsLimitOrderVar = variables.find(v => v.name === "IS_LIMIT_ORDER");
            const xtsVersionVar = variables.find(v => v.name === "VERSION");
            const profitLevels = variables
              .filter(v => v.name.startsWith("PROFIT_PERCENTAGE_LEVEL_"))
              .sort((a, b) => a.name.localeCompare(b.name))
              .map(v => v.value === '' ? '-' : v.value);
            const lossLevels = variables
              .filter(v => v.name.startsWith("LOSS_PERCENTAGE_LEVEL_"))
              .sort((a, b) => a.name.localeCompare(b.name))
              .map(v => v.value === '' ? '-' : v.value);

            const bucketMappings = [
              {
                prefix: 'IDX_OPT_PROFIT_PERCENTAGE_LEVEL_',
                key: 'IDX_OPT_PROFIT_PERCENTAGE'
              },
              {
                prefix: 'IDX_OPT_LOSS_PERCENTAGE_LEVEL_',
                key: 'IDX_OPT_LOSS_PERCENTAGE'
              },
              {
                prefix: 'COM_OPT_PROFIT_PERCENTAGE_LEVEL_',
                key: 'COM_OPT_PROFIT_PERCENTAGE'
              },
              {
                prefix: 'COM_OPT_LOSS_PERCENTAGE_LEVEL_',
                key: 'COM_OPT_LOSS_PERCENTAGE'
              },
              {
                prefix: 'COM_FUT_PROFIT_PERCENTAGE_LEVEL_',
                key: 'COM_FUT_PROFIT_PERCENTAGE'
              },
              {
                prefix: 'COM_FUT_LOSS_PERCENTAGE_LEVEL_',
                key: 'COM_FUT_LOSS_PERCENTAGE'
              }
            ];

            const bucketPercentages = [];

            bucketMappings.forEach(mapping => {
              const values = variables
                .filter(v => v.name.startsWith(mapping.prefix))
                .sort((a, b) => a.name.localeCompare(b.name))
                .map(v => v.value === '' ? '-' : v.value);

              if (values.length > 0) {
                bucketPercentages.push({
                  variable: mapping.key,
                  value: values.join(',')
                });
              }
            });

            this.isBucketEmpty = bucketPercentages.length === 0;
            this.user = {
              ...this.user,
              userId: userData.userId || '',
              firstName: userData.firstName || '',
              lastName: userData.lastName || '',
              nickName: userData.nickName || '',
              secret: userData.secret || '',
              pin: userData.pin || '',
              apiKey: userData.apiKey || '',
              apiSecret: userData.apiSecret || '',
              feeder: userData.feeder || false,
              status: userData.status || '',
              broker: userData.brokerId || '',
              totpSecret: userData.totpSecret || '',
              portfolioSize: portfolioSizeVar ? portfolioSizeVar.value : '',
              profitPercentage: profitLevels.length > 0 ? profitLevels.join(',') : '',
              lossPercentage: lossLevels.length > 0 ? lossLevels.join(',') : '',
              portfolioProfitEnabled: userData.userProperties?.portfolioProfitEnabled || '',
              squareoffEnabled: userData.userProperties?.squareoffEnabled || '',
              host: userData.userProperties?.host || '',
              port: userData.userProperties?.port || '',
              type: userData.userProperties?.type || '',
              username: userData.userProperties?.username || '',
              password: userData.userProperties?.password || '',
              xtsPort: xtsPortVar ? xtsPortVar.value : '',
              xtsLimitPercentage: xtsLimitPercentageVar ? xtsLimitPercentageVar.value : '',
              xtsCommonUrl: commonUrlVar ? commonUrlVar.value : '',
              xtsIsLimitOrder: this.toBool(xtsIsLimitOrderVar?.value),
              xtsVersion: xtsVersionVar ? xtsVersionVar.value : '',
              types: types.length > 0 ? types : [{ type: '', multiplier: '' }],
              bucketPercentages,
            };
          }
        })
        .catch(error => {
          console.error("Error fetching user details:", error);
        });
    },
    validateMultiplier(entry) {
      let value = parseInt(entry.multiplier, 10);
      if (isNaN(value) || value <= 0) {
        entry.multiplier = '';
      } else {
        entry.multiplier = value;
      }
    },
    getActiveBrokers() {
      const data = { type: 'active-brokers' };
      return this.$store.dispatch('commonStore/getReferenceData', data, { root: true })
        .then((response) => {
          const raw = response.server?.data || [];
          this.brokerOptions = raw.map((item) => ({ id: parseInt(item.key, 10), name: item.value }));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toggleShow(field) {
      this.show[field] = !this.show[field];
    },
    getPortfolioNames() {
      const data = {
        type: 'portfolio-name'
      };
      const cacheKey = `${data.type}-reference-data`;
      const cached = sessionStorage.getItem(cacheKey);
      if (cached) {
        const parsed = JSON.parse(cached);
        this.typeOptions = parsed.map((item) => item.value);
        return Promise.resolve();
      }
      return this.$store.dispatch('commonStore/getReferenceData', data, { root: true })
        .then((response) => {
          const options = response.server?.data || [];
          this.typeOptions = options.map((item) => item.value);
          sessionStorage.setItem(cacheKey, JSON.stringify(options));
        })
        .catch((error) => {
          console.error("Failed to fetch portfolio names:", error);
        });
    },
    buildUserProperties() {
      const base = {
        squareoffEnabled: this.user.squareoffEnabled,
        portfolioProfitEnabled: this.user.portfolioProfitEnabled,
      };
      ['host', 'port', 'type', 'username', 'password'].forEach((k) => {
        const v = this.user[k];
        if (v !== undefined && v !== null && String(v).trim() !== '') {
          base[k] = typeof v === 'string' ? v.trim() : v;
        }
      });
      return base;
    },
    handleOnboard() {
      const typeObj = {};
      const multiplierObj = {};
      this.user.types.forEach((entry, index) => {
        typeObj[`type${index + 1}`] = entry.type;
        multiplierObj[`multiplier${index + 1}`] = entry.multiplier;
      });
      const cleanedProfit = (this.user.profitPercentage || '')
        .split(',')
        .map(val => val.trim() === '-' ? '' : val.trim())
        .join(',');
      const cleanedLoss = (this.user.lossPercentage || '')
        .split(',')
        .map(val => val.trim() === '-' ? '' : val.trim())
        .join(',');
      const bucketData = {};
      this.user.bucketPercentages.forEach(entry => {
        if (!entry.variable) return;
        const cleanedValue = (entry.value || '')
          .split(',')
          .map(val => val.trim() === '-' ? '' : val.trim())
          .join(',');

        bucketData[entry.variable] = cleanedValue;
      });
      const payload = [
        {
          userId: this.user.userId,
          firstName: this.user.firstName,
          lastName: this.user.lastName,
          nickName: this.user.nickName,
          secret: this.user.secret,
          pin: this.user.pin,
          apiKey: this.user.apiKey,
          apiSecret: this.user.apiSecret,
          feeder: this.user.feeder,
          status: this.user.status,
          broker: this.user.broker,
          port: this.user.xtsPort,
          limitPercentage: this.user.xtsLimitPercentage,
          commonUrl: this.user.xtsCommonUrl,
          isLimitOrder: this.user.xtsIsLimitOrder,
          version: this.user.xtsVersion,
          totpSecret: this.user.totpSecret,
          portfolioSize: this.user.portfolioSize,
          profitPercentage: cleanedProfit,
          lossPercentage: cleanedLoss,
          userProperties: this.buildUserProperties(),
          type: typeObj,
          multiplier: multiplierObj,
          idxOptionProfitPercentage:
            bucketData.IDX_OPT_PROFIT_PERCENTAGE || '',

          idxOptionLossPercentage:
            bucketData.IDX_OPT_LOSS_PERCENTAGE || '',

          comOptionProfitPercentage:
            bucketData.COM_OPT_PROFIT_PERCENTAGE || '',

          comOptionLossPercentage:
            bucketData.COM_OPT_LOSS_PERCENTAGE || '',

          comFutProfitPercentage:
            bucketData.COM_FUT_PROFIT_PERCENTAGE || '',

          comFutLossPercentage:
            bucketData.COM_FUT_LOSS_PERCENTAGE || '',
        }
      ];
      if (this.isEditMode) {
        this.$store.dispatch("userStore/updateUser", payload, { root: true })
          .then(() => {
            Swal.fire('Success', 'User updated successfully!', 'success');
            this.redirectToUsers();
          })
          .catch(error => {
            console.error("Failed to update user:", error);
            Swal.fire('Error', 'Failed to update user.', 'error');
          });
      } else {
        this.$store.dispatch("userStore/onBoardNewUsers", payload, { root: true })
          .then(() => {
            Swal.fire({
              title: 'User Onboarded Successfully',
              text: 'Would you like to onboard another user?',
              icon: 'success',
              showCancelButton: true,
              cancelButtonText: 'Back to Users',
              confirmButtonText: 'Onboard Next',
              reverseButtons: true,
              buttonsStyling: false,
              customClass: {
                confirmButton: 'btn btn-success',
                cancelButton: 'btn btn-outline-secondary ml-2'
              }
            }).then(result => {
              if (result.isConfirmed) {
                this.onboardNext();
              } else {
                this.redirectToUsers();
              }
            });
          })
          .catch(error => {
            console.error("Failed to onboard user:", error);
            Swal.fire({
              title: 'Error',
              text: 'Something went wrong while onboarding the user.',
              icon: 'error',
              confirmButtonText: 'Close',
              buttonsStyling: false,
              customClass: {
                confirmButton: 'btn btn-danger'
              }
            });
          });
      }
    },
    onboardNext() {
      this.resetForm();
      this.hideModal();
    },
    redirectToUsers() {
      this.hideModal();
      this.$router.push({ name: 'Users' });
    },
    hideModal() {
      if (this.bootstrapModalInstance) {
        this.bootstrapModalInstance.hide();
      }
    },
    resetForm() {
      this.user = {
        userId: '',
        firstName: '',
        lastName: '',
        nickName: '',
        pin: '',
        apiKey: '',
        apiSecret: '',
        totpSecret: '',
        secret: '',
        broker: '',
        status: '',
        portfolioProfitEnabled: '',
        squareoffEnabled: '',
        lossPercentage: '',
        profitPercentage: '',
        portfolioSize: '',
        feeder: false,
        types: [{ type: '', multiplier: '' }],
        host: '',
        port: '',
        type: '',
        username: '',
        password: '',
        xtsPort: '',
        xtsLimitPercentage: '',
        xtsCommonUrl: '',
        xtsIsLimitOrder: false,
        xtsVersion: '',
        bucketPercentages: [],
      };
    },
    addType() {
      this.user.types.push({ type: '', multiplier: '' });
    },
    removeType(index) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'Do you really want to delete this Type & Multiplier?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, Delete it!',
        cancelButtonText: 'Cancel',
        reverseButtons: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-secondary ml-2'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          this.user.types.splice(index, 1);
          Swal.fire({
            title: 'Deleted!',
            text: 'The Type & Multiplier has been removed.',
            icon: 'success',
            timer: 1500,
            showConfirmButton: false
          });
        }
      });
    },
    cancel() {
      this.$router.push({ name: 'Users' });
    },
    handlePortfolioSizeInput(event, field) {
      const raw = event.target.value.replace(/,/g, '');
      if (/^\d*$/.test(raw)) {
        field.value = raw;
        this.user.portfolioSize = raw;
      }
    },
    initializeBucket() {
      this.isBucketEmpty = false;

      if (this.user.bucketPercentages.length === 0) {
        this.user.bucketPercentages.push({
          variable: '',
          value: ''
        });
      }
    },

    addBucket() {
      this.user.bucketPercentages.push({
        variable: '',
        value: ''
      });
    },

    removeBucket(index) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'Do you really want to remove this Bucket?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, Remove it!',
        cancelButtonText: 'Cancel',
        reverseButtons: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-secondary ml-2'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          this.user.bucketPercentages.splice(index, 1);

          if (this.user.bucketPercentages.length === 0) {
            this.isBucketEmpty = true;
          }
        }
      });
    },
  }
};
</script>